import { Editor, Node } from 'slate';
import { getQueryOptions, WithQueryOptions } from '../utils/match';

export function getPrevious<T extends Node>(editor: Editor, options?: WithQueryOptions<typeof Editor.previous, 1>) {
    return Editor.previous<T>(editor, getQueryOptions(editor, options));
}
